import ApeironDialog from '@src/components/share/apeiron/ApeironDialog'
import usePreventLeave from '@src/hooks/common/router/usePreventLeave'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const ApeironUnsavePopup: FC<Props> = (props: Props) => {
  const { haveChanges } = props

  const { t } = useTranslation()

  const { showExitModal, performChange, reset } = usePreventLeave({
    haveChanges
  })

  const handleOnClose = useCallback(() => {
    reset()
  }, [reset])

  const handleOnConfirm = useCallback(() => {
    performChange()
  }, [performChange])

  return (
    <ApeironDialog
      open={showExitModal}
      leftButton={t('common.button.yes')}
      rightButton={t('common.cancel')}
      onClose={handleOnClose}
      onLeftClick={handleOnConfirm}
      onRightClick={handleOnClose}
    >
      {t('unsave.title')}
    </ApeironDialog>
  )
}

type Props = {
  haveChanges: () => boolean
}

export default ApeironUnsavePopup
